import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import styled from 'styled-components';



import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from "@mui/material/styles";
import theme from "../style/theme.js";


/** Composants */
import Logo from '../components/Logo.js'
import NavBar from '../components/NavBar.js'
import Footer from '../components/Footer.js'
import ElementAssociation from '../components/ElementAssociation.js'

/** Api */
import { apiListe, apiElementById } from '../api.js';

const Page = styled.div`
position:relative;
min-height:100vh;
padding-bottom:300px;
`
const Titre = styled.h2`
margin:10px auto;
`
const PageAssociation = () => {
    const {typeElement, id, typeElementAAssocier} = useParams()

    const [liste, setListe] = useState([])
    const [elementCourant, setElementCourant] = useState(null)
    const [loading, setLoading] = useState(true)
    const [erreur, setErreur] = useState(false)

    useEffect(() => {
        apiElementById(typeElement, id)
        .then(res => {
            setElementCourant(res.reponse)
        })
        apiListe(typeElementAAssocier, '*')
        .then(res => {
            setListe(res.reponse)
            setLoading(false)
        })
        .catch(error => {
            console.log(error)
            setLoading(false)
            setErreur(true)
        })
   }, [id, typeElement, typeElementAAssocier])

    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Titre>Association {typeElement} avec {typeElementAAssocier} </Titre>
            {elementCourant && (typeElement === 'motclef') && <p>Je recherche l'élément parent de l'élément <em>{elementCourant.libelle}</em></p>}
            {elementCourant && (typeElement === 'theatre') && <p>J'associe des photos au theatre <em>{elementCourant.site} ({elementCourant.type_ed})</em></p>}
            { !loading  && !erreur && liste
            && <ElementAssociation
                key={id}
                id={id}
                typeElement={typeElement}
                typeElementAAssocier={typeElementAAssocier}
                liste={liste}/>}
            {loading  && <ThemeProvider  theme={theme}><CircularProgress color="secondary"/><h3>Je charge</h3></ThemeProvider> }
            {erreur  && <h3>J'ai rencontré un problème...</h3> }
            <Footer/>
        </Page>
    )
}
export default PageAssociation
